module.exports = __webpack_public_path__ + "app/bento-components/blog-entry/media/default-image.svg";